
import React, { useMemo, useState, useCallback } from "react";
import {
    PieChart,
    Pie,
    Cell,
} from "recharts";

const COLORS = {
    ORDENES_SIN_ASIGNAR: "#ffc107",
    ORDENES_EN_PROCESO: "#17a2b8",
    ORDENES_ENTREGADAS: "#2ECC71",
    ORDENES_CANCELADAS: "#dc3545",
    EQUIPO_RETIRADO: "#100f11",
};

const CATEGORY_CONFIG = [
    // { key: "ORDENES_TOTALES", label: "Órdenes Totales" },
    { key: "ORDENES_SIN_ASIGNAR", label: "Sin Asignar" },
    { key: "ORDENES_EN_PROCESO", label: "En Proceso" },
    { key: "ORDENES_ENTREGADAS", label: "Entregadas" },
    { key: "ORDENES_CANCELADAS", label: "Canceladas" },
    { key: "EQUIPO_RETIRADO", label: "Equipo Retirado" },
    // { key: "DIAGNOSTICOS_EXTRAS", label: "Diagnósticos Extras" },
];

export const OrdersDistributionChart = React.memo(({ data }) => {

    const [visibleKeys, setVisibleKeys] = useState(
        CATEGORY_CONFIG.map((c) => c.key)
    );

    const { chartData, total, lookup } = useMemo(() => {

        const safeData = CATEGORY_CONFIG.map((cat) => ({
            key: cat.key,
            label: cat.label,
            value: Number(data?.[cat.key]) || 0,
        }));

        const filtered = safeData
            .filter(item => visibleKeys.includes(item.key))
            .filter(item => item.value > 0);

        const total = filtered.reduce(
            (acc, item) => acc + item.value,
            0
        );

        const chartData = filtered.map(item => ({
            ...item,
            percentage: total > 0
                ? (item.value / total) * 100
                : 0,
        }));

        const lookup = {};

        chartData.forEach(item => {
            lookup[item.key] = item;
        });

        return { chartData, total, lookup };

    }, [data, visibleKeys]);

    const toggleCategory = useCallback((key) => {
        setVisibleKeys(prev =>
            prev.includes(key)
                ? prev.filter(k => k !== key)
                : [...prev, key]
        );
    }, []);

    return (
        <div className="card border-0 shadow-sm">
            <div className="card-body p-4">

                <h4 className="fw-bold mb-1">
                    Distribución de Órdenes
                </h4>

                <div className="text-muted">
                    Por estatus y categoría
                </div>

                {/* DONUT / EMPTY STATE */}
                <div
                    className="position-relative d-flex justify-content-center align-items-center"
                    style={{ width: "100%", height: 280 }}
                >
                    {chartData.length === 0 ? (
                        <div className="text-center text-muted">
                            No hay datos disponibles
                        </div>
                    ) : (
                        <>
                            <PieChart width={250} height={250}>
                                <Pie
                                    data={chartData}
                                    dataKey="value"
                                    innerRadius={80}
                                    outerRadius={110}
                                    paddingAngle={2}
                                    isAnimationActive={false}
                                >
                                    {chartData.map((entry) => (
                                        <Cell
                                            key={entry.key}
                                            fill={COLORS[entry.key]}
                                        />
                                    ))}
                                </Pie>
                            </PieChart>

                            {/* Centro dinámico */}
                            <div className="position-absolute text-center">
                                <h2 className="fw-bold mb-0">
                                    {(Number(data?.ORDENES_TOTALES) || 0).toLocaleString("es-MX")}
                                </h2>
                                <div className="text-muted small fw-semibold">
                                    ÓRDENES
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {/* LEYENDA */}
                <div className="mt-2">
                    {CATEGORY_CONFIG.map((cat) => {

                        const item = lookup[cat.key];

                        const percentage = item
                            ? item.percentage.toFixed(0)
                            : 0;

                        const active = visibleKeys.includes(cat.key);

                        return (
                            <div
                                key={cat.key}
                                className="d-flex justify-content-between align-items-center mb-2"
                                style={{
                                    cursor: "pointer",
                                    opacity: active ? 1 : 0.4,
                                }}
                                onClick={() => toggleCategory(cat.key)}
                            >
                                <div className="d-flex align-items-center">
                                    <span
                                        style={{
                                            width: 10,
                                            height: 10,
                                            borderRadius: 50,
                                            backgroundColor: COLORS[cat.key],
                                            display: "inline-block",
                                            marginRight: 10,
                                        }}
                                    />

                                    <span className="text-muted fw-semibold">
                                        {cat.label}
                                    </span>
                                </div>

                                <span className="fw-bold">
                                    {percentage}%
                                </span>
                            </div>
                        );
                    })}
                </div>

            </div>
        </div>
    );
});
